<div class="container-fluid loader-container">
    <header class="d-flex space-between page-header">
        <h2>
            Queue messages
        </h2>
        <div class="card-buttons">
            <button (click)="sync()" class="btn btn-primary">
                SYNCEN
            </button>
        </div>
    </header>

    <app-table-guru [apiEndpoint]="'/office/queue-messages'" [columnMapping]="[
            { key: 'id', label: 'ID' },
            { key: 'reference_id', label: 'REF ID' },
            { key: 'client.name', label: 'Client' },
            { key: 'type', label: 'Type' },
            { key: 'incoming', label: 'In', type: 'enum', enum: {'0': '<span class=\'badge text-bg-primary\'>UIT</span>', '1': '<span class=\'badge text-bg-success\'>IN</span>'} },
            { key: 'processed', label: 'Verwerkt',  type: 'enum', enum: {'0': '<i class=\'bi bi-arrow-clockwise text-muted\'></i>', '1': '<i class=\'bi bi-check-circle-fill text-success\'></i>'} },
            { key: 'error_process', label: 'Error',  type: 'enum', enum: {'0': '', '1': '<i class=\'bi bi-exclamation-diamond-fill text-danger\'></i>'}  },
            { key: 'created_at', label: 'Aangemaakt', type: 'dateTime' },
          ]" 
          [customActionButtons]="[
            { title: 'Bekijk', component: viewReference, size: 'xl'}
          ]" 
          [itemsPerPage]="10" [openModalComponent]="editFormReference" [reload]="reloadItems">
    </app-table-guru>
</div>